import './index.d';

import * as network from './network';
import * as sdk from './sdk';
import * as user from './user';

// const t = (services: object) => 
//     Object.entries(services).reduce<any>((memo, [service, req]) => {
//         memo[service] = req
//         return memo
//     }, {});

const Services: ServicesType = {
    ...network,
    ...sdk,
    ...user,
}

export default Services

